import { PEN_ACCENT_COLOR } from '../constants/pen-chrome'
import type { PenAnchorPoint } from '@/lib/elements/types/pen-anchor-point'

interface PenAnchorMarkersProps {
  points: PenAnchorPoint[]
  /** Half the anchor square's side (canvas units). */
  anchorHalf: number
  /** Close-path ring stroke width (canvas units). */
  sw: number
  /** Anchor square outline width (canvas units). */
  handleStrokeWidth: number
  /** Cursor is within closing distance of the first anchor. */
  isNearFirst: boolean
}

/** Anchor squares plus the close-path ring on the first anchor — display only. */
export function PenAnchorMarkers({
  points,
  anchorHalf,
  sw,
  handleStrokeWidth,
  isNearFirst,
}: PenAnchorMarkersProps) {
  return (
    <>
      {/* Anchor squares — all white fill with blue stroke during drawing */}
      {points.map((pt) => (
        <rect
          key={pt.id}
          x={pt.x - anchorHalf}
          y={pt.y - anchorHalf}
          width={anchorHalf * 2}
          height={anchorHalf * 2}
          fill="white"
          stroke={PEN_ACCENT_COLOR}
          strokeWidth={handleStrokeWidth}
          pointerEvents="none"
        />
      ))}

      {/* Close-path indicator ring on first point when cursor is near */}
      {isNearFirst && points.length >= 2 && (
        <circle
          cx={points[0].x}
          cy={points[0].y}
          r={anchorHalf * 1.6}
          fill="none"
          stroke={PEN_ACCENT_COLOR}
          strokeWidth={sw}
          pointerEvents="none"
        />
      )}
    </>
  )
}
